import { defineMessages } from 'react-intl';

export const contextLinkingButtonMessages = defineMessages({
  linkAConsultation: {
    defaultMessage: 'Link a visit', id: 'vEef/WU04o',
    description: 'Submenu label to link a visit session as chat context',
  },
  findAConsultation: {
    defaultMessage: 'Find a visit', id: 'fy9NZ9jpKc',
    description: 'Search placeholder in the visit linking submenu',
  },
  linkAPatient: {
    defaultMessage: 'Link a patient', id: '9ZSw6tYz5Y',
    description: 'Submenu label to link a patient as chat context',
  },
  findAPatient: {
    defaultMessage: 'Find a patient', id: 'GOzJGMwCFV',
    description: 'Search placeholder in the patient linking submenu',
  },
  noPatientsFound: {
    defaultMessage: 'No patients found', id: 'gXpSOTMqoB',
    description: 'Empty state when patient search returns no results',
  },
  unknownPatient: {
    defaultMessage: 'Unknown Patient', id: 'AoEdp6lljw',
    description: 'Fallback label for a patient without a name',
  },
  addFile: {
    defaultMessage: 'Add file', id: 'WGwSD94X+u',
    description: 'Label for attaching a file to the chat',
  },
  addConsultPatientHistoryOrFiles: {
    defaultMessage: 'Add visit, patient history or files', id: 'QR+Vv7zOL2',
    description: 'Tooltip on the context linking button in the chat composer',
  },
  addContext: {
    defaultMessage: 'Add context', id: 'gWm4uzeoP0',
    description: 'Title of the mobile bottom-sheet for adding chat context (session, patient, file)',
  },
});
